import { useState, useEffect, useCallback } from "react";

const addZero = (num) => (num < 10 ? `0${num}` : num);

const calculateElapsedTime = expiredTime => !expiredTime ? 0 : ~~expiredTime;

const useTimerCounter = (totalSecond = 0, endTimeCallbackFn = () => {}) => {
  const [unix, setUnix] = useState(totalSecond);
  const [timeRemaining, setTimeRemaining] = useState(
    calculateElapsedTime(unix)
  );

  const changeUnixHandler = useCallback((t) => {
    setUnix(t);
    setTimeRemaining(calculateElapsedTime(t));
  }, []);

  useEffect(() => {
    if (!unix) {
      return;
    }
    const timerInterval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime === 0) {
          endTimeCallbackFn();
          clearInterval(timerInterval);
          return 0;
        } else {
          return prevTime - 1;
        }
      });
    }, 1000);

    return () => timerInterval && clearInterval(timerInterval);
  }, [endTimeCallbackFn, unix]);

  const hours = Math.floor(timeRemaining / 3600);
  const minutes = Math.floor((timeRemaining % 3600) / 60);
  const seconds = timeRemaining % 60;
  
  return {
    h: hours,
    m: minutes,
    s: seconds,
    seconds: timeRemaining,
    changeUnixHandler,
    full: `${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}`,
  };
};

export default useTimerCounter;
